import { useCallback, useRef } from 'react';

const SOUND_NAMES = ['default', 'gentle', 'pop', 'classic'] as const;

export function useNotificationSound() {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const getSrc = useCallback((name: string): string => {
    if (name === 'custom') return localStorage.getItem('custom_sound') || '/sounds/default.wav';
    if (SOUND_NAMES.includes(name as any)) return `/sounds/${name}.wav`;
    return '/sounds/notification.mp3';
  }, []);

  const playSound = useCallback((type: 'message' | 'like') => {
    const key = type === 'message' ? 'sound_message' : 'sound_like';
    const soundChoice = localStorage.getItem(key) || 'default';
    if (soundChoice === 'none') return;

    if (audioRef.current) { audioRef.current.pause(); audioRef.current.src = ''; }
    const audio = new Audio(getSrc(soundChoice));
    audio.volume = 0.5;
    audio.play().catch(() => {});
    audioRef.current = audio;
  }, [getSrc]);

  const testSound = useCallback((name: string) => {
    if (name === 'none') return;
    const audio = new Audio(getSrc(name));
    audio.volume = 0.5;
    audio.play().catch(() => {});
  }, [getSrc]);

  return { playSound, testSound };
}
